module.exports = __webpack_public_path__ + "img/lc.fab391b3.png";